/** Persist intended destination across email login and Google OAuth. */
export const AUTH_RETURN_KEY = "authReturnUrl";

export function getSafeReturnPath(path, fallback = "/") {
  if (!path || typeof path !== "string") return fallback;
  if (!path.startsWith("/") || path.startsWith("//")) return fallback;
  if (path.startsWith("/login") || path.startsWith("/registration")) return fallback;
  return path;
}

export function rememberReturnUrl(path) {
  const safe = getSafeReturnPath(path, "");
  if (safe) {
    try {
      sessionStorage.setItem(AUTH_RETURN_KEY, safe);
    } catch {
      /* ignore */
    }
  }
}

export function consumeReturnUrl(fallback = "/") {
  let stored = "";
  try {
    stored = sessionStorage.getItem(AUTH_RETURN_KEY) || "";
    sessionStorage.removeItem(AUTH_RETURN_KEY);
  } catch {
    /* ignore */
  }
  return getSafeReturnPath(stored, fallback);
}
